/* Coolors Exported Palette - coolors.co/44af69-f8333c-fcab10-2b9eb3-dbd5b5 */

// common colors and what not
/*
white       #ffffff
dark blue   #022b3a
blue        #1f7a8c
light blue  #bfdbf7
gray        #e1e5f2

*/
export default {
  background: '#022b3a',
  heading: '#ffffff',
  text: '#e1e5f2',
  link: '#de6e4b',
  visitedLink: '#de6e4b',
  nav: '#bfdbf7',
  subHeading: '#bfdbf7',
  imageBorder: '#dddddd'
}

